const STARRED_PROJECTS_KEY = 'starred_projects'

/**
 * Get all starred project IDs from localStorage
 */
export const getStarredProjectIds = (): string[] => {
  try {
    const starred = localStorage.getItem(STARRED_PROJECTS_KEY)
    if (starred) {
      return JSON.parse(starred)
    }
    return []
  } catch (error) {
    console.error('Error reading starred projects from localStorage:', error)
    return []
  }
}

/**
 * Check if a project is starred
 */
export const isProjectStarred = (projectId: string): boolean => {
  const starredIds = getStarredProjectIds()
  return starredIds.includes(projectId)
}

/**
 * Add a project to starred (save to localStorage)
 */
export const addStarredProject = (projectId: string): void => {
  try {
    const starredIds = getStarredProjectIds()
    if (!starredIds.includes(projectId)) {
      starredIds.push(projectId)
      localStorage.setItem(STARRED_PROJECTS_KEY, JSON.stringify(starredIds))
    }
  } catch (error) {
    console.error('Error saving starred project to localStorage:', error)
  }
}

/**
 * Remove a project from starred (remove from localStorage)
 */
export const removeStarredProject = (projectId: string): void => {
  try {
    const starredIds = getStarredProjectIds()
    const filteredIds = starredIds.filter(id => id !== projectId)
    localStorage.setItem(STARRED_PROJECTS_KEY, JSON.stringify(filteredIds))
  } catch (error) {
    console.error('Error removing starred project from localStorage:', error)
  }
}

/**
 * Toggle starred status of a project
 */
export const toggleStarredProject = (projectId: string): boolean => {
  if (isProjectStarred(projectId)) {
    removeStarredProject(projectId)
    return false
  } else {
    addStarredProject(projectId)
    return true
  }
}

